import { toast } from "react-toastify";
import { reservarSala } from "../services/salas";

export const handleReservation = async (roomId, scheduleId, reserverName, closeModal) => {
  try {
    const response = await reservarSala(roomId, scheduleId, reserverName);
    toast.success(`Reserva confirmada para ${reserverName}!`);
    if (closeModal) closeModal(); // Fecha o modal após a reserva, se a função for fornecida
  } catch (error) {
    console.error("Erro ao reservar a sala:", error);
    toast.error(error.message || "Erro ao reservar a sala. Por favor, tente novamente.");
  }
};